/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Johannes_Butzbach_Gymnasium4Inputs */

const en__field__enum_schoolname_johannes_butzbach_gymnasium4 = /** @type {(inputs: _Field__Enum_Schoolname_Johannes_Butzbach_Gymnasium4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miltenberg`)
};

const de__field__enum_schoolname_johannes_butzbach_gymnasium4 = /** @type {(inputs: _Field__Enum_Schoolname_Johannes_Butzbach_Gymnasium4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Johannes-Butzbach-Gymnasium`)
};

/**
* | output |
* | --- |
* | "Miltenberg" |
*
* @param {_Field__Enum_Schoolname_Johannes_Butzbach_Gymnasium4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_johannes_butzbach_gymnasium4 = /** @type {((inputs?: _Field__Enum_Schoolname_Johannes_Butzbach_Gymnasium4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Johannes_Butzbach_Gymnasium4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_johannes_butzbach_gymnasium4(inputs)
	return de__field__enum_schoolname_johannes_butzbach_gymnasium4(inputs)
});
export { _field__enum_schoolname_johannes_butzbach_gymnasium4 as "_field__enum_schoolName_Johannes_Butzbach_Gymnasium" }